// extracted by mini-css-extract-plugin
export default {"bar":"scrollProgress_bar__l6emF"};